import React from "react";
import ConfirmationModal from "../../../components/modals/ConfirmationModal";
import EmailExemptionService from "../../../services/EmailExemptions";

const DeleteEmailExemptionModal = ({ exemptionId, onDelete }) => {
  const handleDelete = async () => {
    try {
      await EmailExemptionService.deleteEmailExemption(exemptionId);
    } catch (e) {
      return e;
    }
    onDelete(exemptionId);
  };
  return (
    <ConfirmationModal
      actionDescription="Delete"
      buttonColor="grey"
      onConfirm={handleDelete}
      menuTrigger
      icon="trash"
      warning
    >
      <p>Are you sure you want to delete this Email Exemption?</p>
    </ConfirmationModal>
  );
};

export default DeleteEmailExemptionModal;
